import api from '../../plugins/api';

const getIntegratioPolesPrice = (params) => {
  return api.get('/api/shop/getIntegratioPolesPrice', params);
};

export default getIntegratioPolesPrice;
